import { createStore, combineReducers, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import elementary from './_initializer_reducers';
import applicants from './_applicantions_reducers';
import auth from './_auth_reducer';
import companies from './_companies_reducers';
import vacancies from './_vacancies_reducer';
// import admin from './_admin_reducers';
import platform from './_platform_reducer';
import users from './_users_reducer';
import skills from './_skills_reducer';
import postsReducer from './_news_reducer';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export default () => {
  const store = createStore(
    combineReducers({
      elementary,
      auth,
      // company,
      vacancies,
      // student: studentsReducer,
      // admin,
      platform,
      users,
      companies,
      // companyUsers: companyUsers,
      // userPermission: companyUsersPermission,
      // backend: backendReducer,
      // applicant,
      // activity: ActivityReducer,
      skills,
      // userHistory: userHistory,
      posts: postsReducer,
      applicants,
      // pagination: paginationReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))
  );
  return store;
};
